import { render, staticRenderFns } from "./UserMoney.vue?vue&type=template&id=acbd1e6a&scoped=true"
import script from "./UserMoney.vue?vue&type=script&lang=js"
export * from "./UserMoney.vue?vue&type=script&lang=js"
import style0 from "./UserMoney.vue?vue&type=style&index=0&id=acbd1e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbd1e6a",
  null
  
)

export default component.exports